import { AttachmentFileList } from 'owa-attachment-file-types';
import { lazyLogAttachOrShareDatapoint } from 'owa-attachment-filepicker';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { InlineImagePlugin } from 'owa-inline-image';
import { lazyCreateAttachments } from 'owa-mail-compose-actions';
import { ComposeViewState } from 'owa-mail-compose-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

// This function assumes the caller is an AttachmentFilePicker for logging purposes.
// Pass in an action source if calling from elsewhere.
export async function aFPCreateAttachmentHandler(
    files: AttachmentFileList,
    inlineImagePlugin: InlineImagePlugin,
    viewState: ComposeViewState,
    properties: CreateAttachmentsProperties,
    dataProvider: AttachmentDataProviderType
): Promise<void> {
    const isPlainText = viewState.bodyType != 'HTML';
    const processInlineImageBeforeUpload = isPlainText
        ? null
        : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);

    const createAttachments = await lazyCreateAttachments.import();
    createAttachments(files, viewState, properties, processInlineImageBeforeUpload);
    const logAttachOrShareDatapoint = await lazyLogAttachOrShareDatapoint.import();
    logAttachOrShareDatapoint({
        files: files,
        isInline: properties.isInline,
        shouldShare: properties.shouldShare,
        dataProviderType: dataProvider,
    });
}
